import React, { ReactNode, useState } from 'react'
import { Swiper } from 'swiper/react'
import styles from './GenericSlider.module.sass'

interface Props {
  id?: string
  conf?: any // parametri di Swiper
  theme?: 'light' | 'dark' | 'neutral10'
  notch?: boolean
  navigationPos?: 'middle' | 'pagination' | 'bottom'
  children?: ReactNode
  className?: string
  navClassName?: string
  paginationClassName?: string
}

const GenericSlider = (props: Props) => {
  const {
    id = undefined,
    conf = {},
    theme = 'light',
    notch = false,
    navigationPos = undefined,
    children = undefined,
    className = '',
    navClassName = undefined,
    paginationClassName = undefined,
  } = props

  const [allowNav, setAllowNav] = useState({ prev: true, next: true })

  const handleNav = (s) => {
    setAllowNav({
      prev: s.allowSlidePrev,
      next: s.allowSlideNext,
    })
  }

  const renderNavButton = (type: 'prev' | 'next') => (
    <button
      id={`${id}_${type}`}
      type="button"
      className={`${navClassName} swiper-button-${type} ${
        !allowNav[type]
          ? Object.values(allowNav).filter((x) => x).length === 0
            ? 'swiper-button-lock'
            : 'swiper-button-disabled'
          : ''
      } ${styles[type]}`}
    />
  )
  const renderPagination = () => (
    <div
      className={`${paginationClassName} swiper-pagination ${styles.pagination}`}
      id={`${id}_pagination`}
    ></div>
  )

  const swiperParams = {
    ...conf,
    pagination:
      conf.pagination && conf.navigation && navigationPos === 'pagination'
        ? {
            ...conf.pagination,
            el: `#${id}_pagination`,
          }
        : conf.pagination,
    navigation: conf.navigation
      ? {
          ...conf.navigation,
          prevEl: `#${id}_prev`,
          nextEl: `#${id}_next`,
        }
      : undefined,
    onSwiper: (s) => {
      handleNav(s)
      if (conf.onSwiper) conf.onSwiper(s)
    },
    onSlideChange: (s) => {
      handleNav(s)
      if (conf.onSlideChange) conf.onSlideChange(s)
    },
    className: `${styles.swiper} ${conf?.zoom ? 'swiper--zoom' : ''} ${conf.className || ''}`,
  }

  return children ? (
    <div
      className={`${styles.root} ${styles[`root--nav-${navigationPos}`]} ${
        notch ? 'swiperScope--notch' : ''
      } ${`swiperScope--${theme}`} ${className}`}
    >
      <Swiper {...swiperParams}>{children}</Swiper>
      {conf.navigation &&
        /* se la navigazione è accanto alla paginazione, devo gestire esternamente anche la paginazione perchè non so quanto è larga */
        (conf.pagination && navigationPos === 'pagination' ? (
          <div className={styles.bottom}>
            {renderNavButton('prev')}
            {renderPagination()}
            {renderNavButton('next')}
          </div>
        ) : (
          <>
            {renderNavButton('prev')}
            {renderNavButton('next')}
          </>
        ))}
    </div>
  ) : (
    <></>
  )
}

export default GenericSlider
